/**
 * {@docCategory ScrollablePane}
 */
export var ScrollbarVisibility = {
    auto: 'auto',
    always: 'always'
};
//# sourceMappingURL=ScrollablePane.types.js.map